import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface IUserSnapApi {
  init: (params: Record<string, unknown>) => void;
  destroy: () => void;
}

declare const window: Window & {
  onUsersnapLoad?: (api: IUserSnapApi) => void;
};

@Injectable({
  providedIn: 'root',
})
export class UsersnapService {
  private script: HTMLScriptElement | undefined;
  public userSnapApi: IUserSnapApi | undefined;

  public initialize(initParams: Record<string, unknown> = {}): Promise<IUserSnapApi> {
    return new Promise<IUserSnapApi>((resolve) => {
      window.onUsersnapLoad = (api: IUserSnapApi) => {
        api.init(initParams);
        this.userSnapApi = api;
        resolve(api);
      };

      this.script = document.createElement('script');
      this.script.defer = true;
      this.script.src = `https://widget.usersnap.com/global/load/${environment.usersnapSpaceApiKey}?onload=onUsersnapLoad`;
      document.head.appendChild(this.script);
    });
  }

  public onDestroy(): void {
    this.userSnapApi?.destroy();
    this.script?.remove();
  }
}
